import { useState } from "react";

import { downloadExcel } from "utils/exportToExcel";

/**
 * Icon-only "Export to Excel" button used across list/report pages.
 * Matches the filter button styling (btn btn-link); the label appears as a
 * native tooltip on hover.
 *
 * Props:
 *   apiFn:    function that issues the export request (must return a blob)
 *   params:   object passed to apiFn — typically current page filters
 *   filename: fallback filename if server omits Content-Disposition
 *   disabled: optional override
 *   title:    optional, tooltip text (defaults to "Export to Excel")
 *   className:optional, defaults to "list-view btn btn-link" matching filter button
 */
const ExcelExportButton = ({
  apiFn,
  params,
  filename = "export.xlsx",
  disabled = false,
  title = "Export to Excel",
  className = "list-view btn btn-link",
}) => {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (loading) return;
    setLoading(true);
    try {
      await downloadExcel(apiFn, params, filename);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      className={className}
      onClick={handleClick}
      disabled={disabled || loading}
      title={title}
      aria-label={title}
    >
      <i
        className={
          loading ? "fa fa-spinner fa-spin" : "las la-download"
        }
      />
    </button>
  );
};

export default ExcelExportButton;
